define('lq/fileUpload',[
    'jquery',
    'underscore',
    'when',
    './fileUtil'
], function ($, _, when, fileUtil) {

    var defaults = {
        action: undefined,
        accept: undefined,
        maxFileSizeInKb: undefined,
        maxImageDimensions: undefined,
        params: {},
        multiple: false,
        actionId: undefined,
        dropId: undefined,
        onMaxFileSizeExceeded: $.noop,
        onInvalidFileExtension: $.noop,
        onStart: $.noop,
        onUploadingFile: $.noop,
        onFileUploading: $.noop,
        onFileUploaded: $.noop,
        onFileUploadCancel: $.noop,
        onFinished: $.noop,
        onFilesSelected: null
    };

    var FileUpload = function(config) {
        this.config = $.extend({}, defaults, config || {});
    };

    FileUpload.prototype.do = function() {
        var $input = $('<input type="file" />')
            .hide();

        if (this.config.multiple)
            $input.attr('multiple', 'multiple');

        if (this.config.accept)
            $input.attr('accept', this.config.accept);

        $input
            .on('change', this.onFilesSelected.bind(this))
            .on('cancel', this.config.onFileUploadCancel.bind(this))
            .appendTo($('body'))
            .trigger('click');
    };

    FileUpload.prototype.onFilesSelected = function(e) {
        var files = Array.prototype.slice.call(e.target.files);

        var largeFile = this.tryToFindFileThatExceedsMaxFileSize(files);
        var invalidFile = this.isAllowedExtension(files);

        if (largeFile) {
            this.config.onMaxFileSizeExceeded(largeFile.name);
        } else if (invalidFile) {
            this.config.onInvalidFileExtension(invalidFile.name);
        } else if (this.config.onFilesSelected) {
            this.config.onFilesSelected(files);
        } else {
            this.config.onStart();

            var self = this;
            files.reduce(function (previous, file, i) {
                return previous
                    .then(function() {
                        self.config.onUploadingFile(files.length, i);
                        return self.getDataToSend(file);
                    })
                    .then(function (data) {
                        return self.sendFile(data, file.name);
                    })
                    .then(function (response) {
                        if (!response.success && response.errorType === 'sizeLimitExceeded')
                            self.config.onMaxFileSizeExceeded(file.name, response.errorValue);
                        else if (!response.success && response.errorType === 'invalidFileType')
                            self.config.onInvalidFileExtension(file.name);
                        else
                            self.config.onFileUploaded(response);
                    });
                }, when.resolve())
                .then(function () {
                    self.config.onFinished();
                });
        }
    };

    FileUpload.prototype.tryToFindFileThatExceedsMaxFileSize = function(files) {
        if (!this.config.maxFileSizeInKb)
            return undefined;

        var maxFilesSizeInBytes = this.config.maxFileSizeInKb * 1024;
        return _.find(files, function(f) {
            return f.size > maxFilesSizeInBytes;
        });
    };

    FileUpload.prototype.isAllowedExtension = function(files) {
        if (!this.config.accept)
            return undefined;

        var extList = this.config.accept.split(',').map(function(ext) {
            return ext.replace('/*', '').trim().toLowerCase();
        });

        return _.find(files, function(f) {
            var filename = f.name;
            var ext = (-1 !== filename.indexOf('.')) ? filename.replace(/^.*(\.[^.]+)$/, '$1').toLowerCase() : '';
            var type = f.type.split('/')[0] !== 'application' ? f.type.split('/')[0] : f.type;
            return !_.contains(extList, ext) && !_.contains(extList, type);
        });
    };

    FileUpload.prototype.sendFile = function (data, filename) {
        var deferred = when.defer();
        var self = this;

        var params = $.extend({}, this.config.params);
        params.qqfile = filename; // stay backwards compatible until qqfileuploader is removed everywhere

        if (this.config.actionId && this.config.dropId) {
            params.actionId = this.config.actionId;
            params.dropId = this.config.dropId;
        }

        var url = this.config.action + '?' + $.param(params);

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var jsonResponse = JSON.parse(xhr.responseText);
            deferred.resolve(jsonResponse);
        };
        xhr.upload.onprogress = function (event) {
            self.config.onFileUploading(Math.round(event.loaded / event.total * 100));
        };
        xhr.open('POST', url, true);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.setRequestHeader("X-File-Name", encodeURIComponent(filename));
        xhr.setRequestHeader("Content-Type", "application/octet-stream");
        xhr.send(data);

        return deferred.promise;
    };

    FileUpload.prototype.getDataToSend = function (file) {
        if (!this.shouldTryToResize(file))
            return file;

        var deferred = when.defer();

        var maxWidth = this.config.maxImageDimensions.x;
        var maxHeight = this.config.maxImageDimensions.y;

        var reader = new FileReader();
        reader.onload = function (readerEvent) {
            var image = new Image();
            image.onload = function () {
                var canvas = document.createElement('canvas');

                if (image.width <= maxWidth && image.height <= maxHeight) {
                    deferred.resolve(file);
                } else {
                    var targetWidth = image.width;
                    var targetHeight = image.height;

                    if (targetWidth > maxWidth) {
                        targetWidth = maxWidth;
                        targetHeight = image.height / image.width * maxWidth;
                    }

                    if (targetHeight > maxHeight) {
                        targetHeight = maxHeight;
                        targetWidth = image.width / image.height * maxHeight;
                    }

                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    canvas.getContext('2d').drawImage(image, 0, 0, targetWidth, targetHeight);

                    var dataUrl = canvas.toDataURL(file.type);
                    var blob = fileUtil.dataUrlToBlob(dataUrl);

                    deferred.resolve(blob);
                }
            }
            image.src = readerEvent.target.result;
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    };

    FileUpload.prototype.shouldTryToResize = function(file) {
        return this.config.maxImageDimensions && file.type.match(/image.*/);
    };

    return FileUpload;
});
